// Simple device utilities
// Detect if the current device is primarily touch-based
export function isTouchDevice() {
  if (typeof window === 'undefined') return false;
  // Prefer coarse pointer detection when available
  try {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
  } catch (_e) { /* noop */ }
  return ('ontouchstart' in window) || (navigator && navigator.maxTouchPoints > 0);
}
